import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import { i18n } from './language/i18n'
import registerGlobalComponents from './registerGlobalComponents'

registerGlobalComponents()

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
